import { CorporateLocationDto } from '../corporate-location/corporate-location.dto';

/**
 * Lifecycle of a corporation. Its own enum on the API, distinct from
 * `FacilityStatus` despite carrying the same members.
 *
 * TODO(BE): `Suspended` is not reachable today. The column exists and is
 * persisted, but the only write in the API sets `Active` at registration —
 * there is no suspend endpoint, no status field on the update DTO, and nothing
 * reads it to gate behaviour. Anything keying off `Suspended` is dormant until
 * that is built.
 */
export enum CorporationStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Suspended = 'Suspended',
  PendingApproval = 'PendingApproval',
  Rejected = 'Rejected'
}

export interface CorporationDto {
  id: string; // Guid
  name: string;
  description?: string | null;
  email: string;
  phone?: string | null;
  website?: string | null;
  logoUrl?: string | null;
  address?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
  timeZone?: string | null;
  businessHours?: string | null;
  isActive: boolean;
  createdAt: string; // DateTime as ISO string
  updatedAt?: string | null; // DateTime as ISO string
  locations?: CorporateLocationDto[] | null;
  status: CorporationStatus;
  zipCode?: string | null;
}
